import React from "react";
import PropTypes from "prop-types";
import "./HuiSegmentedBar.scss";

export const HuiSegmentedBar = ({
  segments = 3,
  width = "100px",
  level = 0,
  ...props
}) => {
  return (
    <span className="hireart-ds-segmented-bar" style={{ width }}>
      <table width={width} {...props}>
        <tbody>
          <tr>
            {Array(segments)
              .fill(segments)
              .map((_v, idx) => (
                <td
                  key={idx}
                  className={`${idx + 1 <= level ? "filled" : ""}`}
                />
              ))}
          </tr>
        </tbody>
      </table>
    </span>
  );
};

HuiSegmentedBar.propTypes = {
  segments: PropTypes.number.isRequired,
  level: PropTypes.number,
  width: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
};

